(ns frontend.ui.component.icon.view
  "Encapsulation of https://fontawesome.com/search?s=solid%2Cbrands"
  (:require ))

(def ^:private ->variant
  {:duotone "d"
   :light   "l"
   :regular "r"
   :solid   "s"
   :thin    "t"})

(defn icon
  "`id` is a keyword picked from icons name
  https://fontawesome.com/search?s=solid%2Cbrands"
  ([id] (icon {} id))
  ([{:keys [class variant on-click]
     :or   {variant :light}
     :as   props}
    id]
   [:div
    {:class    "inline-block cursor-pointer"
     :on-click (:on-click props)}
    [:i
     (merge
      {:class (str "fa" (->variant variant)
                   " fa-" (name id)
                   " "
                   (:class props))}
      (when on-click
        {:style {:cursor "pointer"}}))]]))
